<template>
  <v-row>
    <input-text v-if="$route.query.codigoSimulacao || $route.query.codigoProposta" label="Tipo de Cálculo"
      :value="model.VencimentoPersonalizado || model.TipoCalculoFluxo === $aux.TipoFluxoEnum.Irregular ? 'Irregular' : 'Regular'"
      readonly disabled />
    <input-select v-else label="Tipo de Cálculo" v-model="model.TipoCalculoFluxo" :options="TipoFluxo" required
      @change="changeTipoCalculo" />
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon color="primary" v-on="on" class="mb-6 ml-2">ph-question</v-icon>
      </template>
      <p> <b>Fluxo Regular</b>: Parcelas idênticas, vencimento a cada 30 dias após carência (se houver)
        <br> <b>Fluxo Irregular</b>: Parcelas com valores e vencimentos personalizados
      </p>
    </v-tooltip>
  </v-row>
</template>
<script>
export default {
  props: {
    value: null,
  },
  data () {
    return {
      TipoFluxo: this.$param.TipoFluxo || [
        {
          text: 'Regular',
          value: 1
        },
      ]
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
  },
  methods: {
    changeTipoCalculo () {
      this.$emit('changeTipoCalculo')
    }
  }
}
</script>
